
type ThemeMode = 'light' | 'dark';

const THEME_KEY = 'theme-preference';
let currentTheme: ThemeMode = 'light';

export function getStoredTheme(): ThemeMode | null {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
    return null;
}

export function getSystemTheme(): ThemeMode {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: ThemeMode): void {
    currentTheme = theme;
    if (theme === 'dark') {
        document.body.classList.add('theme-dark');
    } else {
        document.body.classList.remove('theme-dark');
    }
    localStorage.setItem(THEME_KEY, theme);
}

export function initTheme(): ThemeMode {
    const theme = getStoredTheme() ?? getSystemTheme();
    applyTheme(theme);
    return theme;
}

export function toggleTheme(): ThemeMode {
    const next = currentTheme === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    return next;
}

export function getCurrentTheme(): ThemeMode {
    return currentTheme;
}